'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setConfig = setConfig;
exports.getConfig = getConfig;

var _constants = require('../constants');

var defaults = {
  SEARCH_SERVICE: typeof global.SEARCH_SERVICE !== 'undefined' ? global.SEARCH_SERVICE : _constants.DEFAULT_CONFIG.URI,
  DOMAIN_CULTURE: typeof global.hr !== 'undefined' && typeof global.hr.intl !== 'undefined' ? global.hr.intl.DOMAIN_CULTURE : 'es-es',
  PARTNERS: null,
  RATING_PRICES_RANGE: _constants.DEFAULT_CONFIG.RATING_PRICES_RANGE[typeof global.hr !== 'undefined' && typeof global.hr.intl !== 'undefined' ? global.hr.intl.DOMAIN_CULTURE : 'es-es'],
  SEARCH_POLYGON: null
};

function _setConfig(prop, value) {
  if (prop in defaults) defaults[prop] = value;
}

function setConfig(_config) {
  Object.keys(_config).forEach(function (prop) {
    return _setConfig(prop, _config[prop]);
  });
}

function getConfig(prop) {
  return prop ? defaults[prop] : defaults;
}